interface InformationOptionLabelProps {
    label: string;
}

function InformationOptionLabel({ label }: InformationOptionLabelProps) {
    return (
        <div className="text-foreground min-w-0 flex-1">
            <span className="text-base">{label}</span>
        </div>
    );
}

export default InformationOptionLabel;
